export enum QueueConditionField {
    "Código de error" = "ERROR_CODE",
    "Descripción de error" = "ERROR_DESCRIPTION",
    "Dominio" = "DOMAIN",
    "Tipo de tarea" = "FORM_NAME" ,
    "Actividad" = "ACTIVITY",
    "Tipo RFS" = "RFS_REQUEST"
}